<form #actualForm="ngForm" class="dt-form" [formGroup]="usernameForm" (ngSubmit)="onSubmit()">
  <mat-form-field>
    <mat-label i18n>Benutzername</mat-label>
    <input matInput type="text" formControlName="username" placeholder="Kein Benutzername" i18n-placeholder />
  </mat-form-field>

  @if (usernameForm.hasError('server-error')) {
    <mat-error i18n>Bei der Übertragung der Daten ist ein Fehler aufgetreten</mat-error>
  }

  <button
    mat-raised-button
    [dtOverlayProgress]="usernameForm.disabled"
    type="submit"
    color="accent"
    [disabled]="usernameForm.controls.username.value === originalUsername || usernameForm.disabled"
    i18n
    >Speichern</button
  >
</form>
